"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _compose = _interopRequireDefault(require("recompose/compose"));
var _pure = _interopRequireDefault(require("recompose/pure"));
var _withState = _interopRequireDefault(require("recompose/withState"));
var _angieslistAppPlatform = require("angieslist-app-platform");
var _stringUtils = _interopRequireDefault(require("angieslist-app-platform/lib/common/utils/stringUtils"));
var _getErrorMessage = _interopRequireDefault(require("angieslist-app-platform/lib/common/getErrorMessage"));
var _Alert = _interopRequireDefault(require("angieslist-react-components/lib/Alert"));
var _Button = _interopRequireDefault(require("angieslist-react-components/lib/Button"));
var _ButtonToolbar = _interopRequireDefault(require("angieslist-react-components/lib/ButtonToolbar"));
var _Panel = _interopRequireDefault(require("angieslist-react-components/lib/Panel"));
var _ButtonGroup = _interopRequireDefault(require("angieslist-react-components/lib/ButtonGroup"));
var _changePasswordModal = _interopRequireDefault(require("./modals/changePasswordModal"));
var _personalDetailsModal = _interopRequireDefault(require("./modals/personalDetailsModal"));
var PersonalDetails = function PersonalDetails(_ref) {
  var editButtonStyle = _ref.editButtonStyle,
    _ref$fetchUser = _ref.fetchUser,
    isUserLoading = _ref$fetchUser.isLoading,
    user = _ref$fetchUser.response,
    userError = _ref$fetchUser.error,
    changeUserPasswordApi = _ref.changeUserPasswordApi,
    resetChangeUserPassword = _ref.resetChangeUserPassword,
    changePassword = _ref.changePassword,
    showPasswordModal = _ref.showPasswordModal,
    setPasswordShowModal = _ref.setPasswordShowModal,
    showDetailsModal = _ref.showDetailsModal,
    setDetailsShowModal = _ref.setDetailsShowModal;
  var handlePasswordShow = function handlePasswordShow() {
    return setPasswordShowModal(true);
  };
  var handlePasswordClose = function handlePasswordClose() {
    return setPasswordShowModal(false);
  };
  var handleDetailsShow = function handleDetailsShow() {
    return setDetailsShowModal(true);
  };
  var handleDetailsClose = function handleDetailsClose() {
    return setDetailsShowModal(false);
  };
  var errorMessage = (0, _getErrorMessage["default"])(userError);
  return /*#__PURE__*/_react["default"].createElement(_Panel["default"], null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Heading, null, /*#__PURE__*/_react["default"].createElement(_Panel["default"].Title, null, "Personal Details")), /*#__PURE__*/_react["default"].createElement(_Panel["default"].Body, null, errorMessage ? /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    bsStyle: "danger"
  }, errorMessage) : null, !isUserLoading && !(0, _isEmpty2["default"])(user) ? [/*#__PURE__*/_react["default"].createElement("dl", {
    className: "dl-horizontal",
    key: "0"
  }, /*#__PURE__*/_react["default"].createElement("dt", null, "Email Address:"), /*#__PURE__*/_react["default"].createElement("dd", null, user.email), /*#__PURE__*/_react["default"].createElement("dt", null, "Name:"), /*#__PURE__*/_react["default"].createElement("dd", null, user.firstName, " ", user.lastName), /*#__PURE__*/_react["default"].createElement("dt", null, "Home Phone:"), /*#__PURE__*/_react["default"].createElement("dd", null, _stringUtils["default"].formatPhoneNumber((0, _get2["default"])(user, 'primaryContactInformation.primaryPhoneNumber'))), /*#__PURE__*/_react["default"].createElement("dt", null, "Mobile:"), /*#__PURE__*/_react["default"].createElement("dd", null, _stringUtils["default"].formatPhoneNumber((0, _get2["default"])(user, 'primaryContactInformation.mobilePhoneNumber')))), /*#__PURE__*/_react["default"].createElement(_ButtonToolbar["default"], {
    key: "1"
  }, /*#__PURE__*/_react["default"].createElement(_personalDetailsModal["default"], {
    user: user,
    editButtonStyle: editButtonStyle,
    showModal: showDetailsModal,
    handleClose: handleDetailsClose
  }), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "personal-details--edit-button",
    flat: true,
    bsStyle: editButtonStyle,
    bsSize: "small",
    style: {
      fontWeight: 'bold'
    },
    onClick: handleDetailsShow
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-btn icon-pencil"
  }), " Edit"))), /*#__PURE__*/_react["default"].createElement(_changePasswordModal["default"], {
    changeUserPasswordApi: changeUserPasswordApi,
    editButtonStyle: editButtonStyle,
    changePassword: changePassword,
    resetChangeUserPassword: resetChangeUserPassword,
    showModal: showPasswordModal,
    handleClose: handlePasswordClose
  }), /*#__PURE__*/_react["default"].createElement(_ButtonGroup["default"], null, /*#__PURE__*/_react["default"].createElement(_angieslistAppPlatform.Track, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "personal-details--change-password-button",
    flat: true,
    bsStyle: editButtonStyle,
    bsSize: "small",
    style: {
      fontWeight: 'bold'
    },
    onClick: handlePasswordShow
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-btn icon-lock"
  }), " Change Password"))))] : null));
};
PersonalDetails.propTypes = {
  editButtonStyle: _propTypes["default"].string.isRequired,
  fetchUser: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    response: _propTypes["default"].shape({
      email: _propTypes["default"].string,
      firstName: _propTypes["default"].string,
      lastName: _propTypes["default"].string,
      primaryContactInformation: _propTypes["default"].shape({
        primaryPhoneNumber: _propTypes["default"].string,
        mobilePhoneNumber: _propTypes["default"].string
      })
    }),
    error: _propTypes["default"].object
  }).isRequired,
  changeUserPasswordApi: _propTypes["default"].func.isRequired,
  resetChangeUserPassword: _propTypes["default"].func.isRequired,
  changePassword: _propTypes["default"].shape({
    isLoading: _propTypes["default"].bool,
    error: _propTypes["default"].object
  }),
  showPasswordModal: _propTypes["default"].bool.isRequired,
  setPasswordShowModal: _propTypes["default"].func.isRequired,
  showDetailsModal: _propTypes["default"].bool.isRequired,
  setDetailsShowModal: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _compose["default"])((0, _withState["default"])('showPasswordModal', 'setPasswordShowModal', false), (0, _withState["default"])('showDetailsModal', 'setDetailsShowModal', false), _pure["default"])(PersonalDetails);
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/browser/components/myAccount/personalDetails.js
// module id = 4059
// module chunks = 9